/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import {
  COMPANY_IMPORT_PERMISSIONS,
  COMPANY_EXPORT_PERMISSIONS,
  COMPANY_VIEW_PERMISSIONS,
} from '../../../constants/permissions';

const CompaniesView = () => import('./components/CompaniesView.vue');
const CompanyProfile = () => import('./pages/CompanyProfile.vue');
const CompaniesDataHub = () => import('./pages/CompaniesDataHub.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/companies'),
    name: 'companies_dashboard',
    meta: {
      permissions: ['administrator', COMPANY_VIEW_PERMISSIONS],
    },
    component: CompaniesView,
  },
  // Mantem nome e caminho antigos: links ja compartilhados continuam funcionando e caem na aba
  // Importar. Quem so tem permissao de exportar tambem precisa alcancar a tela (a checagem e
  // "qualquer uma") e o proprio hub esconde as abas que o usuario nao pode usar.
  {
    path: frontendURL('accounts/:accountId/companies/import'),
    name: 'company_import_spreadsheet',
    meta: {
      permissions: [
        'administrator',
        COMPANY_IMPORT_PERMISSIONS,
        COMPANY_EXPORT_PERMISSIONS,
      ],
    },
    component: CompaniesDataHub,
  },
  {
    path: frontendURL('accounts/:accountId/companies/wallet'),
    name: 'company_wallet',
    meta: {
      permissions: ['administrator', COMPANY_VIEW_PERMISSIONS],
    },
    component: CompaniesView,
    props: () => ({ isWalletView: true }),
  },
  {
    path: frontendURL('accounts/:accountId/companies/custom_view/:id'),
    name: 'companies_segments_dashboard',
    meta: {
      permissions: ['administrator', COMPANY_VIEW_PERMISSIONS],
    },
    component: CompaniesView,
    props: route => {
      return { segmentsId: route.params.id };
    },
  },
  {
    path: frontendURL('accounts/:accountId/companies/:companyId'),
    name: 'company_profile_dashboard',
    meta: {
      permissions: ['administrator', COMPANY_VIEW_PERMISSIONS],
    },
    component: CompanyProfile,
    props: route => {
      return { companyId: route.params.companyId };
    },
  },
];
